import { Component, ViewChild, OnInit, EventEmitter, Output } from '@angular/core';
import { ModalComponent } from '../../../components/modal/modal.component';
import { ToastService } from '../../../components/toast/toast.service';
import { DataService } from '../../../services/data.service';

@Component({
  selector: 'lowy-edit-notes',
  templateUrl: './edit-notes.component.html',
  styleUrls: ['./edit-notes.component.scss'],
})
export class EditNotesComponent implements OnInit {

  public notes: string;

  private dataTypeId: string;
  private id: string;

  @ViewChild('modal') modal: ModalComponent;
  @Output() updated = new EventEmitter<any>();

  constructor(private dataService: DataService, private toastService: ToastService) { }

  async ngOnInit() { }

  public open(dataTypeId: string, id: string) {
    this.dataTypeId = dataTypeId;
    this.id = id;
    this.modal.open();
  }

  async save() {
    await this.dataService.updateNotes(this.dataTypeId, this.id, this.notes);
    this.modal.close();
    this.updated.emit();
    this.toastService.throwToast('Notes updated successfully');
  }

  cancel() {
    this.modal.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/home/data/edit-notes/edit-notes.component.ts